export default __webpack_public_path__ + "media/images/brands/demo/backgrounds/bg-04-63eaa33c74923a2ee43a5b5b653a5107.jpg";